<img class="img-circle" [src]="avatarSrc" [alt]="avatarAlt" [width]="size" [height]="size"/>